import { PageTitle } from '_metronic/layout/core'

import ClickablePlanCard from './Components/ClickablePlanCard'
import PlanDetailModal from './Components/PlanDetailModal'

import useViewModel from './ViewModel'
import { PLANS } from '../Profile/Config'

//////////
// View //
//////////

const PlansView: React.FC = () => {
	const {
		currentActivePlan,
		onPlanClick,
		openPlanDetailModal,
		handleOpenPlanDetailModal,
		handleClosePlanDetailModal,
	} = useViewModel()

	return (
		<ViewPageTitle>
			<PlanDetailModal isOpen={openPlanDetailModal} handleClose={handleClosePlanDetailModal} />

			<div className="row gy-5">
				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header mt-4">
							<div className="card-title">
								{/* Title */}
								<div>
									<h4 className="text-kumopack-grey-900 fw-bold mb-2">Account Plans</h4>
									<div className="text-kumopack-grey-600 fs-6">
										please specify page description here
									</div>
								</div>
							</div>

							<div className="card-toolbar">
								<button
									className="btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold"
									onClick={handleOpenPlanDetailModal}>
									Learn More
								</button>
							</div>
						</div>

						<div className="card-body">
							<div className="row">
								<div className="col-12 col-xl-4">
									<div className="text-kumopack-grey-700">Current Plan</div>
									<p className="text-kumopack-grey-600">
										We'll credit your account if you need to downgrade during the billing cycle.
									</p>
								</div>
								<div className="col-12 col-xl-8">
									<div className="row gy-5">
										{PLANS.map((plan, idx) => (
											<div className="col-12" key={`plan-${idx}`}>
												<ClickablePlanCard
													idx={idx}
													active={currentActivePlan === idx}
													onClick={onPlanClick}
													{...plan}
												/>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'My Account',
						path: '/profile',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Plans',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				บริษัท จินดาสยาม จำกัด
			</PageTitle>

			{children}
		</>
	)
}

export default PlansView
